import React from 'react';

import SocialMediaIcons from './SocialMediaIcons';
import { StyledSocialHome } from './SocialMedia.styled';

function SocialMedia() {
    
  return (
    <>
        <StyledSocialHome>
        <SocialMediaIcons color="#000"/>
        </StyledSocialHome>
    </>
  )
}

export default SocialMedia;